import { game } from './chess';
import {
  chessBoard,
  dailypuzzleData,
  makeMove,
  makedailyMove,
  puzzleHighlightMove,
  puzzleMoveapi,
  puzzleObj,
  puzzlecomplete,
  response,
} from './chessboardMain';
import { gameId, sendsocketData } from '../helpers/socketio';
import { removeDots } from './highlightpossiblemoves';
import { BehaviorSubject } from 'rxjs';

declare let $: any;
export var squareToHighlight: any = null;
export let turn: string = 'your turn';
let mode: number = 1;
export let currentPuzzleMove = 0;
// export let currentPuzzlelevel = 1;
export let gameover: boolean;
export let PlayerRouteId: any;
export let gamedraw: boolean;
export let gameMoveBlock: any;
let difficulty: any;
export let dailyDrop: any;
let moveDailyPuzzle: any;
export let dailyPuzzleFinish = false;
export let WrongMove: any;
const whiteSidePromotion = ['a7', 'b7', 'c7', 'd7', 'e7', 'f7', 'g7', 'h7'];
const blackSidePromotion = ['a2', 'b2', 'c2', 'd2', 'e2', 'f2', 'g2', 'h2'];

export let currentdailyPuzzleMove = 0;
let promotionPiece = '';
let selectedPiece: any;
let selectedSource: any;
let promotionSource: string;
let promotionTarget: string;
let promotionOrientation: any;
let isPromotionPopupShown: boolean;
var squareId: any;
let movemusic = localStorage.getItem('moveSounds');
export let apiFlagBV = new BehaviorSubject<boolean>(false);
export let AiPlayedMove = new BehaviorSubject<boolean>(false);
export let promotionPiecePopup = new BehaviorSubject<boolean>(false);
export let puzzlesolved = new BehaviorSubject<boolean>(false);

export function playergameId(data: any) {
  PlayerRouteId = data;
}

export function puzzleMoveLength(data: any) {
  currentPuzzleMove = data;
  puzzlesolved.next(false);
}

export function moveBlock(data: any) {
  gameMoveBlock = data;
}

export function sendApiFlag() {
  apiFlagBV.next(true);
}

export function sendAiMove() {
  AiPlayedMove.next(true);
}

export function clickDrop(source?: any, piece?: any): any {
  removeDots();

  let userDATA = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
  let games = JSON.parse(localStorage.getItem('gameIdreponse') || '{}');
  if (window.location.pathname === `/play/${games._id}`) {
    if (
      games.whiteSidePlayer !== userDATA.username &&
      games.blackSidePlayer !== userDATA.username
    ) {
      return false;
    }
    if (
      (games.blackSidePlayer == userDATA.username &&
        piece.search(/^w/) !== -1) ||
      (games.blackSidePlayer !== userDATA.username && piece.search(/^b/) !== -1)
    ) {
      return false;
    }
  }

  if (source && piece) {
    selectedPiece = piece;
    if (!selectedSource || game.turn() === selectedPiece.charAt(0))
      selectedSource = source;
  }

  document.querySelectorAll('.square-55d63').forEach((square) => {
    square.addEventListener('click', function () {
      squareId = square.getAttribute('data-square');

      if (selectedSource && selectedPiece) {
        if (window.location.pathname === `/play`) {
          if (game.turn() === 'b') return;
          if (difficulty == null || difficulty == undefined) {
            if (game.turn() === 'w') return;
          }
        }

        if (window.location.pathname !== `/puzzle`) {
          if (
            gameMoveBlock == 'completed' ||
            gameMoveBlock == 'resign' ||
            gameMoveBlock == 'draw' ||
            gameMoveBlock == 'timeout' ||
            gameMoveBlock == 'checkmate'
          ) {
            return;
          }
        }

        if (gamedraw) return;

        if (window.location.pathname === `/openings`) {
          return;
        }

        if (window.location.pathname === `/puzzle/complatedpuzzle`) {
          return;
        }

        if (window.location.pathname === `/puzzle`) {
          if (response === null) {
            return;
          }
        }
        if (window.location.pathname === `/historyboard/${PlayerRouteId}`) {
          return;
        }
        if (selectedSource === squareId) return;

        ondrop(selectedSource, squareId);
        removeDots();
        selectedPiece = null;
        selectedSource = null;
      }
      chessBoard.position(game.fen());
    });
  });
}

export async function ondrop(
  source: any,
  target: any,
  orientation?: any
): Promise<any> {
  if (window.location.pathname === `/play`) {
    if (game.turn() === 'b') return;
    if (difficulty == null || difficulty == undefined) {
      if (game.turn() === 'w') return;
    }
  }

  if (window.location.pathname !== `/puzzle`) {
    if (
      gameMoveBlock == 'completed' ||
      gameMoveBlock == 'resign' ||
      gameMoveBlock == 'draw' ||
      gameMoveBlock == 'timeout' ||
      gameMoveBlock == 'checkmate'
    ) {
      return;
    }
  }

  if (gamedraw) return;

  if (window.location.pathname === `/openings`) {
    return;
  }

  if (window.location.pathname === `/puzzle/complatedpuzzle`) {
    return;
  }

  if (window.location.pathname === `/puzzle`) {
    if (response === null) {
      return;
    }
  }
  if (window.location.pathname === `/historyboard/${PlayerRouteId}`) {
    return;
  }

  if (source === target) return;

  if (
    (game.get(source)?.type === 'p' &&
      game.get(source)?.color === 'w' &&
      target[1] === '8' &&
      whiteSidePromotion.includes(source)) ||
    (game.get(source)?.type === 'p' &&
      game.get(source)?.color === 'b' &&
      target[1] === '1' &&
      blackSidePromotion.includes(source))
  ) {
    if (promotionPiece == '') {
      if (!isPromotionPopupShown) {
        showPromotionPopup(source, target, orientation);
      }
      return;
    }
  }

  let move: any = game.move({
    from: source,
    to: target,
    promotion: promotionPiece, // NOTE: always promote to a queen for example simplicity
  });

  if (window.location.pathname !== `/puzzle`) {
    sendApiFlag();
  }

  // illegal move
  if (move === null) return 'snapback';

  $('#pgnmove').html(game.pgn());
  updateBoard();

  $('#hijk .box').remove();

  if (window.location.pathname === `/play/${gameId}`) {
    sendsocketData(game.pgn());
  }

  if (window.location.pathname === `/play`) {
    sendAiMove();
  }

  if (game.isGameOver() == true) {
    gameover = true;
  }

  if (window.location.pathname === `/puzzle`) {
    if (response !== null) {
      if (move.lan == puzzleObj) {
        puzzlecurrentMove();
        if (puzzleMoveapi.length == currentPuzzleMove) {
          $('#puzzleHit').hide();
          $('#puzzlemove').hide();
          puzzlecomplete();
          removeDots();
          WrongMove = 1;
          currentPuzzleMove = 0;
          puzzlesolved.next(true);
          $('#puzzlesolve').html('Puzzle solved.');
          $('#nextPuzzle').show();
        }
      } else {
        WrongMove = 0;
        puzzlecomplete();
        undoMove();
        updateBoard();
      }
    }
  }

  if (window.location.pathname === `/puzzle/dailypuzzle`) {
    if (move.lan === dailypuzzleData) {
      dailypuzzlecurrentMove();
      if (moveDailyPuzzle.length === currentdailyPuzzleMove) {
        dailyPuzzleFinish = true;
        localStorage.setItem('dailyPuzzleFinish', 'true');
        currentdailyPuzzleMove = 0;
        $('#dailypuzzleHit, #puzzlesThemes, #puzzlesMovesDialogue').hide();
        $('#solveMorePuzzlesBtn').show();
      }
    } else {
      undoMove();
      updateBoard();
    }
  }

  currentPuzzleMove > 0 &&
    setTimeout(() => makeMove(currentPuzzleMove, puzzleMoveapi), 700);

  currentdailyPuzzleMove > 0 &&
    setTimeout(
      () => makedailyMove(currentdailyPuzzleMove, moveDailyPuzzle),
      700
    );

  removeDots();

  promotionPiece = '';

  highlightLastMove(source, target);
}

function routerMove() {}

function showPromotionPopup(
  source: string,
  target: string,
  orientation: any
): void {
  promotionSource = source;
  promotionTarget = target;
  promotionOrientation = orientation;
  isPromotionPopupShown = true; // Set the state variable

  promotionPiecePopup.next(true);
  document.getElementById('queen')!.onclick = () => selectPromotionPiece('q');
  document.getElementById('rook')!.onclick = () => selectPromotionPiece('r');
  document.getElementById('bishop')!.onclick = () => selectPromotionPiece('b');
  document.getElementById('knight')!.onclick = () => selectPromotionPiece('n');
}

export function getEliminatedPieces(fen: any) {
  const startingPosition =
    'rnbqkbnrpppppppp................................PPPPPPPPRNBQKBNR';
  const fenParts = fen.split(' ');
  const fenPosition = fenParts[0];
  const rows = fenPosition.split('/');
  let currentPosition = '';

  // Convert FEN rows to a single string representing the board
  for (let row of rows) {
    for (let char of row) {
      if (isNaN(char)) {
        currentPosition += char;
      } else {
        currentPosition += '.'.repeat(parseInt(char));
      }
    }
  }

  const eliminatedPieces: any = {
    white: { P: 8, R: 2, N: 2, B: 2, Q: 1, K: 1 },
    black: { p: 8, r: 2, n: 2, b: 2, q: 1, k: 1 },
  };

  // Subtract the pieces found in the current position
  for (let piece of currentPosition) {
    if (eliminatedPieces.white[piece] !== undefined) {
      eliminatedPieces.white[piece]--;
    } else if (eliminatedPieces.black[piece] !== undefined) {
      eliminatedPieces.black[piece]--;
    }
  }

  // Gather eliminated pieces
  const eliminatedList: any = { white: [], black: [] };
  for (let piece in eliminatedPieces.white) {
    if (eliminatedPieces.white[piece] > 0) {
      for (let i = 0; i < eliminatedPieces.white[piece]; i++) {
        eliminatedList.white.push(piece);
      }
    }
  }
  for (let piece in eliminatedPieces.black) {
    if (eliminatedPieces.black[piece] > 0) {
      for (let i = 0; i < eliminatedPieces.black[piece]; i++) {
        eliminatedList.black.push(piece);
      }
    }
  }

  return eliminatedList;
}

function selectPromotionPiece(piece: string): any {
  promotionPiece = piece;
  isPromotionPopupShown = false;
  promotionPiecePopup.next(false);

  ondrop(promotionSource, promotionTarget, promotionOrientation);
  chessBoard.position(game.fen());
}

export function AIdifficulty(data: any) {
  if (data !== undefined) {
    difficulty = data.difficulty;
  } else {
    difficulty = undefined;
  }
}

export function dailyPuzzledrop(data: any) {
  dailyDrop = data;
  moveDailyPuzzle = dailyDrop.split(' ');
}

export function getNextMoveFromData(movesData: string): string | null {
  const moves = movesData.split(' ');
  const lastMoveIndex = game.history().length;

  return lastMoveIndex < moves.length ? moves[lastMoveIndex] : null;
}

export function highlightNextMove() {
  const nextMove = getNextMoveFromData(puzzleHighlightMove);

  if (nextMove !== null) {
    const [source, target] = [nextMove.slice(0, 2), nextMove.slice(2, 4)];
    highlightSquare(source);
    highlightSquare(target);
  }
}

export function highlightSquare(squareIdOrClass: any) {
  var $square = $('#hijk .square-' + squareIdOrClass);
  if ($square.length > 0) {
    $square.append('<div class="box"></div>');
  }
}

// export function autoAistart(){
//   const aiplayer = JSON.parse(localStorage.getItem('matchedMultiplayer') || '{}')
//       if(aiplayer.player === false){
//         if (window.location.pathname === `/play/${aiplayer.gameId}`) {
//           getPosition(game.fen());
//           if (game.turn() === 'b') {
//             bestMove();
//           }
//         }
//       }
// }

export function puzzlecurrentMove() {
  currentPuzzleMove++;
}

export function dailypuzzlecurrentMove() {
  currentdailyPuzzleMove++;
}
export function undoMove() {
  game.undo();
  chessBoard.position(game.fen());
  const moves: any = game.history({ verbose: true });

  const lastMove = moves.length ? moves[moves.length - 1] : null;
  highlightLastMove(lastMove?.from, lastMove?.to);
}

export function resetChess() {
  game.reset();
  currentdailyPuzzleMove = 0;
  chessBoard.start();
}

export function changeMode() {
  mode = mode === 1 ? 2 : 1;
}

export function updateBoard() {
  // Remove previous highlights
  $('.square-55d63').removeClass('highlight-king');

  // Highlight king in check
  if (game.inCheck()) {
    var board = game.board();
    var kingPos = '';
    for (var i = 0; i < 8; i++) {
      for (var j = 0; j < 8; j++) {
        var piece = board[i][j];
        if (piece && piece.type === 'k' && piece.color === game.turn()) {
          kingPos = String.fromCharCode(97 + j) + (8 - i);
          break;
        }
      }
    }

    if (kingPos) {
      $('#hijk .square-' + kingPos).addClass('highlight-king');
    }
  }
}

export function onMoveEnd() {
  if (movemusic == 'true') {
    playSound();
  }
  $('#hijk .square-' + squareToHighlight).addClass('highlight');
}

export function highlightLastMove(source?: any, target?: any) {
  if (game.turn() === 'b') {
    $('#blackSideTimer').css('opacity', '');
    $('#whiteSideTimer').css('opacity', 0.5);
  } else {
    $('#whiteSideTimer').css('opacity', '');
    $('#blackSideTimer').css('opacity', 0.5);
  }
  // Remove highlights from previous move
  $('#hijk .square-55d63').removeClass('highlight');
  $('#hijk .square-' + source).addClass('highlight');
  $('#hijk .square-' + target).addClass('highlight');
}

function playSound() {
  const audio = new Audio('assets/sounds/Move.mp3'); // Replace with your audio file path
  audio.play().catch((error) => {});
}

// function removeDots() {
//   throw new Error('Function not implemented.');
// }
// function removeDots() {
//   throw new Error('Function not implemented.');
// }
// async function showPromotionDialog(): Promise<string> {
//   return new Promise<string>((resolve, reject) => {
//     const promotionDialog = document.createElement('div');
//     promotionDialog.classList.add('promotion-dialog');
//     promotionDialog.innerHTML = `
//       <p>Select promotion piece:</p>
//       <div class="promotion-options">
//         <img src="path/to/queen.png" alt="Queen" data-piece="q">
//         <img src="path/to/rook.png" alt="Rook" data-piece="r">
//         <img src="path/to/bishop.png" alt="Bishop" data-piece="b">
//         <img src="path/to/knight.png" alt="Knight" data-piece="n">
//       </div>
//     `;
//     promotionDialog.addEventListener('click', (event) => {
//       const selectedPiece = (event.target as HTMLElement).getAttribute('data-piece');
//       if (selectedPiece) {
//         resolve(selectedPiece);
//         document.body.removeChild(promotionDialog);
//       }
//     });
//     document.body.appendChild(promotionDialog);
//   });
// }
